var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row header-block" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6 col-md-7 title header-filters" },
        [
          _vm.tenantsDD
            ? _c("dropdown-checkbox", {
                ref: "tenantsFilterSelect",
                attrs: {
                  "filter-name": "Tenants",
                  "filter-options": _vm.tenants,
                  "selected-item": _vm.selectedTenants,
                  "search-placeholder": "Search for a tenant",
                  "all-options": true,
                  "is-loading": _vm.isLoadingAllTenants,
                },
                on: {
                  "select-filter": _vm.handleFilterSelect,
                  "load-more": _vm.loadMoreTenants,
                  "load-all": _vm.loadAllTenants,
                  search: _vm.loadTenants,
                },
              })
            : _vm._e(),
          _vm.clubsDD
            ? _c("dropdown-checkbox", {
                ref: "clubsFilterSelect",
                attrs: {
                  "filter-name": "Clubs",
                  "filter-options": _vm.clubs,
                  "selected-item": _vm.selectedClubs,
                  "search-placeholder": "Search for a club",
                },
                on: {
                  "select-filter": _vm.handleFilterSelect,
                  "load-more": _vm.loadMoreClubs,
                  search: _vm.loadClubs,
                },
              })
            : _vm._e(),
          _vm.clubsRadioDD
            ? _c("dropdown-radio-button", {
                attrs: {
                  "filter-name": "Clubs",
                  "filter-options": _vm.clubs,
                  "selected-item": _vm.selectedClubs,
                  "select-first-item": true,
                  "show-clear-button": false,
                  "search-placeholder": "Search for a club",
                },
                on: {
                  "select-filter": _vm.handleFilterSelect,
                  "load-more": _vm.loadMoreClubs,
                  search: _vm.loadClubs,
                },
              })
            : _vm._e(),
          _vm.externalEventsFiltersDD
            ? _c("dropdown-checkbox", {
                attrs: {
                  "filter-name": "Event Filters",
                  "filter-options": _vm.monitoringEventFilters,
                  "selected-item": _vm.selectedFilters,
                  "is-search": false,
                },
                on: { "select-filter": _vm.handleFilterSelect },
              })
            : _vm._e(),
          _vm.extensionsDD
            ? _c("dropdown-checkbox", {
                ref: "extensionsFilterSelect",
                attrs: {
                  "filter-name": "Extensions",
                  "filter-options": _vm.extensions,
                  "selected-item": _vm.selectedExtensions,
                  "is-search": false,
                },
                on: { "select-filter": _vm.handleFilterSelect },
              })
            : _vm._e(),
          _vm.datePickerData
            ? _c("date-range-picker", {
                attrs: { format: "DD/MM/YY", mode: _vm.datePickerData.mode },
                on: { input: _vm.updateQueryWithTimeRange },
                model: {
                  value: _vm.dateRanges,
                  callback: function ($$v) {
                    _vm.dateRanges = $$v
                  },
                  expression: "dateRanges",
                },
              })
            : _vm._e(),
          _vm._l(_vm.filterCheckboxes, function (filter, index) {
            return _c(
              "div",
              { key: index, staticClass: "filter" },
              [
                !filter.hidden
                  ? _c(
                      "checkbox",
                      {
                        attrs: { value: filter.value, title: filter.title },
                        on: {
                          input: function ($event) {
                            return _vm.updateFilterCheckbox($event, filter)
                          },
                        },
                      },
                      [_vm._v(_vm._s(filter.title))]
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm.showSearch
        ? _c(
            "div",
            {
              staticClass:
                "col-xs-12 col-sm-6 col-md-5 col-lg-offset-0 pull-right search",
            },
            [
              _c("page-search", {
                attrs: {
                  "multi-search": _vm.multiSearch,
                  "search-filters": _vm.searchFilters,
                },
              }),
              _c("clear-filters", {
                attrs: { filters: _vm.clearableFilters },
                on: { reset: _vm.resetEventFilter },
              }),
              _vm.exportData
                ? _c(
                    "div",
                    {
                      staticClass: "header-button-block-wrapper pull-right",
                      on: { click: _vm.exportData },
                    },
                    [_vm._m(0)]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "separator" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "button-image-link" }, [
      _c("img", { attrs: { src: "assets/images/export.svg", alt: "Export" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }